import { observer } from 'mobx-react';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import app from 'src/../package.json';
import { appStore } from 'src/mobx/appStore';
import versionTimestamp from '~/versionTimestamp.json';
import './style.scss';

const Version: FC = observer((): JSX.Element => {
  return (
    <div className="app-version">
      {window.MOBILE_APP_VERSION ? (
        <>
          <p className="app-version__text color-green">{`APP ${String(window.MOBILE_APP_VERSION || '')}`}</p>
          <p className="app-version__text color-dark">|</p>
        </>
      ) : null}
      {appStore.settings ? (
        <p className="app-version__text color-mainblue">{`UI ${app.version} ${appStore.settings?.release}`}</p>
      ) : (
        <Skeleton width={105} height={12} />
      )}
      <p style={{ display: 'none' }}>{versionTimestamp.timestamp}</p>
    </div>
  );
});

export default Version;
